import React from 'react'

export function Time(props) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 6 6 18M6 6l12 12"></path></svg>
  )
}
export default Time

